import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0001 2H6.00005V4H18.0001V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.0001 5H4.00005V7H20.0001V5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.1612 8H1.83887L3.93887 22H20.0612L22.1612 8ZM15.1667 15L10.5 18.5V11.5L15.1667 15Z"}}]};

const VideoLibraryFilled = Vue.extend<IconProps>({
  name: 'VideoLibraryFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'video-library-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default VideoLibraryFilled;
